// Dev-only toggle, das `scanMeterValue()` und `ocrFromUploadedImage()`
// hart auf `service-unavailable` zurückfallen lässt — dafür da, den
// Manual-Fallback-Mode (siehe MeterReadingView.vue + `anylineUnavailable`)
// ohne fälschlich gesetzten Lizenz-Key durchzuspielen.
//
// Gating wie bei [[useDevMode]]: persistiert in localStorage, aber `active`
// ist nur dann true, wenn (a) Dev-Mode überhaupt verfügbar ist (= nicht
// PROD) UND (b) Dev-Mode aktuell eingeschaltet ist UND (c) der Switch
// selbst eingeschaltet ist. Damit kann ein vergessenes enabled=true im
// localStorage auf einem Production-Host die Simulation nicht auslösen.

import { computed, ref, watch } from "vue";
import { useDevMode } from "./useDevMode";

const STORAGE_KEY = "ene.simulateAnylineFailure";

function readPersisted(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

// Singleton state — wie useDevMode auf Modul-Ebene.
const enabled = ref(readPersisted());

watch(
  enabled,
  (on) => {
    try {
      localStorage.setItem(STORAGE_KEY, on ? "1" : "0");
    } catch {
      /* localStorage unavailable (private mode / SSR) — ignore */
    }
  },
  { flush: "sync" },
);

const { active: devModeActive } = useDevMode();

const active = computed(() => devModeActive.value && enabled.value);

export function useSimulateAnylineFailure() {
  return {
    /** Switch darf gerendert werden? = Dev-Mode aktuell aktiv. */
    available: devModeActive,
    /** Bind-Target für den Switch im UI. */
    enabled,
    /** Echte Wirksamkeit (Dev-Mode aktiv UND Switch on). NUR diese Flag
     *  in Services prüfen — nie direkt `enabled`. */
    active,
  };
}

/** Non-composable Lookup für Services. Identisch zu
 *  `useSimulateAnylineFailure().active.value`, aber ohne Reactive-Setup
 *  am Service-Aufrufpunkt. */
export function isSimulatingAnylineFailure(): boolean {
  return active.value;
}
